import { motion } from "framer-motion";

export default function EngineStartButton({ onClick, size = 150, testId = "engine-start-button" }) {
  return (
    <motion.button
      data-testid={testId}
      onClick={onClick}
      aria-label="Start a project"
      style={{ width: size, height: size }}
      className="relative rounded-full focus:outline-none group cursor-pointer"
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      {/* metallic bezel */}
      <span
        className="absolute inset-0 rounded-full shadow-[0_12px_44px_rgba(0,0,0,0.65)]"
        style={{
          background:
            "conic-gradient(from 210deg, #26262a, #4d4d55, #1c1c1f, #54545c, #26262a)",
        }}
      />
      {/* inner face */}
      <span className="absolute inset-[7px] rounded-full bg-[#101013] border border-white/10 group-hover:border-signal/60 transition-colors duration-500" />
      {/* ignition glow on hover */}
      <span
        className="absolute inset-[7px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{
          boxShadow:
            "0 0 34px rgba(255,42,42,0.4), inset 0 0 22px rgba(255,42,42,0.18)",
        }}
      />
      {/* blinking LED */}
      <span className="led-blink absolute top-[17%] left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-signal" />

      {/* label */}
      <span className="absolute inset-0 flex flex-col items-center justify-center gap-0.5 px-3 text-center">
        <span className="font-mono text-smoke group-hover:text-white/70 transition-colors duration-300 tracking-[0.3em] uppercase" style={{ fontSize: Math.max(7, size * 0.058) }}>
          Engine
        </span>
        <span className="font-display text-white tracking-wide" style={{ fontWeight: 800, fontSize: size * 0.16 }}>
          START
        </span>
        <span className="font-mono text-signal group-hover:text-white transition-colors duration-300 tracking-[0.3em] uppercase" style={{ fontSize: Math.max(7, size * 0.058) }}>
          Project
        </span>
      </span>
    </motion.button>
  );
}
